import * as React from "react"

const MOBILE_BREAKPOINT = 768

// `maxWidth` is inclusive: the viewport counts as mobile when its width is <= maxWidth
export function useIsMobile(maxWidth: number = MOBILE_BREAKPOINT - 1) {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${maxWidth}px)`)
    const onChange = () => {
      setIsMobile(mql.matches)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(mql.matches)
    return () => mql.removeEventListener("change", onChange)
  }, [maxWidth])

  return !!isMobile
}
